import {Component, OnInit} from '@angular/core';
import { ThemeModeService } from 'src/app/_metronic/partials/layout/theme-mode-switcher/theme-mode.service';

@Component({
  selector: 'app-navbar-entities',
  templateUrl: './navbar-entities.component.html',
  styleUrls: ['./navbar-entities.component.scss'],
})
export class NavbarEntitiesComponent implements OnInit {

  currentEntity: any;

  entities = [
    {
      id: 1,
      name: 'Marketzoo',
      svg: './assets/media/logos/entities/marketzoo.com/marketzoo.com_elephant.svg',
      hostname: 'marketzoo.com'
    },
    {
      id: 2,
      name: 'Game Lounge',
      svg: './assets/media/logos/entities/gamelounge.com/gl_logo_primary.svg',
      hostname: 'gamelounge.com'
    },
    {
      id: 4,
      name: 'Adventrum',
      svg: './assets/media/logos/entities/adventrum.com/adventrum_a.svg',
      hostname: 'adventrum.com'
    },
    {
      id: 5,
      name: 'Kiickr',
      svg: './assets/media/logos/entities/kiickr.com/kiickr_no_BG.svg',
      hostname: 'kiickr.com'
    },
    {
      id: 6,
      name: 'TodaysWeb',
      svg: './assets/media/logos/entities/todaysweb.com/todaysweb_white.svg',
      hostname: 'todaysweb.com'
    },
  ];

  constructor(private modeService: ThemeModeService) {

  }

  ngOnInit() {
    if (this.modeService.mode.value == 'light') {
      if (this.entities.length > 0) {
        const lastIndex = this.entities.length - 1;
        if (this.entities[lastIndex].hostname === 'todaysweb.com') {
            this.entities[lastIndex].svg = './assets/media/logos/entities/todaysweb.com/todaysweb_black.svg';
        }
      }
    }
    this.getCurrentEntity();
  }

  getCurrentEntity() {
    for (const entity of this.entities) {
      if (window.location.hostname.includes(entity.hostname)) {
        this.currentEntity = entity;
        return;
      }
    }
  }

  baseUrl(hostname: string) {
    return 'https://' + location.hostname.split('.')[0] + '.' + hostname + location.pathname + location.search;
  }
}
